module.exports = __webpack_public_path__ + "img/yes.2c970bbf.png";